import { useMemo } from 'react';
// Types
import type { IBusiness, IContact, IContactField } from '@trii/types/dist/Contacts/contacts';
import type { UserTrii } from '@trii/types/dist/Users';
import ContactGeneral, { ContactGeneralProps } from './components/ContactGeneral';
import BusinessGeneral, { BusinessGeneralProps } from './components/BusinessGeneral';

export interface GeneralProps {
  dateFormat: string;
  entityType: 'contact' | 'business';
  entityData: IContact | IBusiness;
  customContactFields: IContactField[];
  baseUrl?: string;
  spaceId?: string;
  currentUser?: UserTrii | null;
  onEntityUpdated?: (entity: unknown) => void;
}

const General = (props: GeneralProps) => {
  const { entityType, entityData } = props;

  const normalizedEntityType = useMemo(() => {
    if (entityType === 'contact' || entityType === 'business') return entityType;
    return 'contact';
  }, [entityType]);

  return normalizedEntityType === 'contact' ? (
    <ContactGeneral
      {...(props as ContactGeneralProps)}
      entityData={entityData as IContact}
      entityType="contact"
    />
  ) : (
    <BusinessGeneral
      {...(props as BusinessGeneralProps)}
      entityData={entityData as IBusiness}
      entityType="business"
    />
  );
};

export default General;
